import { NgxSpinnerConfig } from 'node_modules/ngx-spinner/lib/config';

export default {
  type: 'ball-clip-rotate'
} as NgxSpinnerConfig;